<template>
  <thank-you-stepper-base
    image-src="img/svg/thank-you.svg"
    image-container-class="d-flex justify-content-between"
    title="Awesome"
    title-align="center"
    title-class="mt-3"
    message="You have successfully created stockpoint"
    use-row-action
    action-row-class="mt-3"
    action-col-md="12"
    action-button-class="btn btn-block"
    button-text="Done"
    button-btn-color="primary"
    @done="$emit('done')"
  />
</template>
<script>
import ThankYouStepperBase from "@/components/Common/ThankYouStepperBase.vue";

export default {
  name: "ThankYou",
  components: {
    ThankYouStepperBase,
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}
</style>
